import { loadHermesData, getInfo, getError } from 'ha/modules/Hermes';
import NotFoundPage from 'ha/pages/NotFound';
import { getCurrentLanguageCode } from 'ha/modules/LanguageSwitcher/selectors';
import getTranslatedCollection from 'ha/utils/urls/getTranslatedCollection';
import SomethingWentWrongPage from 'ha/pages/SomethingWentWrongPage';

export const getIndexRouteCountry = (
  store,
  urlResolver,
  getComponentsWithNotFound,
) => (nextState, callback) => {
  const countryPageUrl = urlResolver.getHermesCountryPath(
    nextState.params.country,
  );

  store.dispatch(loadHermesData(countryPageUrl)).then(() => {
    const state = store.getState();

    if (getError(state)) {
      return callback(null, { component: SomethingWentWrongPage });
    }

    const info = getInfo(state);

    if (!info || !info.hasData) {
      return callback(null, { component: NotFoundPage });
    }

    const { category } = nextState.params;

    if (!category) {
      return callback(null, {
        getComponent: getComponentsWithNotFound('Country'),
      });
    }

    const language = getCurrentLanguageCode(store.getState());
    const translatedCollection = getTranslatedCollection(
      language,
      encodeURIComponent(category),
    );

    if (translatedCollection) {
      return callback(null, {
        getComponent: getComponentsWithNotFound('Country'),
      });
    }

    return callback(null, {
      component: NotFoundPage,
    });
  });
};
